import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/topbar/header/Header";
import Navbar from "./components/topbar/navbar/Navbar";
import Footer from "./components/footer/Footer";
import AccessibilityToolbar from "./components/accessibility/AccessibilityToolbar";
import VideoModal from "./components/VideoModal/VideoModal";
import ScrollToTop from "./components/ScrollToTop";
import MainRoutes from "./routes/MainRoutes";
import AppAdmin from "./admin/AppAdmin";
import { ThemeProvider } from "./admin/context/ThemeContext";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Admin panel (login + dashboard etc.) */}
        <Route
          path="/admin/*"
          element={
            <ThemeProvider>
              <AppAdmin />
            </ThemeProvider>
          }
        />
        {/* Public website layout and routes */}
        <Route
          path="/*"
          element={
            <div className="App">
              <VideoModal />
              {/* <AccessibilityToolbar /> */}
              <Header />
              <Navbar />
              <MainRoutes />
              <Footer />
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
